var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showConfirmationModal)?_c('Modal',{attrs:{"config":{..._vm.modalConfig.confirmAddNewPayee, title: _vm.modalTitle,
            btn1Label: _vm.cancelButtonLabel}},on:{"btn1Action":function($event){return _vm.makeNewPayment(_vm.config.resp)},"btn2Action":function($event){return _vm.routeToDashboard()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }